import React from 'react'

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';

import AppBarButtons from './AppBarButtons';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';
import { useTheme } from "@mui/material/styles";

const EmbeddedAppBar = (props) => {
	const classes = useStyles();
	const theme = useTheme();
	const isSm = useMediaQuery('(min-width:650px)');

	return (
		<AppBar position="fixed" 
			sx={{
				bottom: 0,
				top: 'auto !important',
				backgroundColor: '#fff !important',
				borderTop: '1px solid ' + theme.palette.primary.dark,
				'& .MuiToolbar-root': {
					justifyContent: 'space-between',
					maxWidth: '100% !important',
				},
				'& .MuiToolbar-root .MuiButton-root:first-child': {
					fontWeight: 'bold',
				},
				'& a, button, h6, p': {
					color: theme.palette.primary.dark + ' !important',
				},
				
			}}
			elevation={4}
		>
			<Toolbar className={classes.toolbar}>
				<Button color="inherit" 
					startIcon={<KeyboardArrowUpIcon />}
					onClick={props.onClick}
					>
					{isSm ? 'U-MAS for Members menu' : 'U-MAS menu'}
				</Button>
				<div className={classes.appBarButtons}>
				<AppBarButtons 
					showCart={true}
					isMain={true}
				/>
				</div>
			</Toolbar>
		</AppBar>
	
)}

export default EmbeddedAppBar